<script context="module">
    export function formValidation(
        fields,
        values,
        onlyThisField,
        options = {}
    ) {
        let defaultRegexp = /^[a-zA-ZÀ-ÿ\s]{1,40}$/;
        let valid = true;
        let firstInvalidFieldName = null;

        const shouldFocus = options.shouldFocus ?? onlyThisField == null;

        Object.keys(values).forEach((fieldName) => {
            let field = fields[fieldName];
            if (
                field != null &&
                (onlyThisField == null || onlyThisField == fieldName)
            ) {
                let regexp =
                    field.regexp != null ? field.regexp : defaultRegexp;
                field.error =
                    shouldValidateField(field, values[fieldName]) &&
                    !regexp.test(values[fieldName]);

                if (valid) {
                    valid =
                        !shouldValidateField(field, values[fieldName]) ||
                        regexp.test(values[fieldName]);
                    if (!valid && !firstInvalidFieldName) {
                        firstInvalidFieldName = fieldName;
                    }
                }
            }
        });

        if (shouldFocus && firstInvalidFieldName) {
            window.setTimeout(function () {
                const input = document.getElementsByName(firstInvalidFieldName);
                if (input[0]) input[0].focus();
            }, 0);
        }

        return valid;
    }

    function shouldValidateField(field, value) {
        return field.required || value.length > 0;
    }

    export const personalDetailsFields = {
        nombre: {
            error: false,
            errorMessage: 'Ingresa un nombre válido',
            required: true,
        },
        segundoNombre: {
            error: false,
            errorMessage: 'Ingresa un nombre válido',
            required: false,
        },
        apPaterno: {
            error: false,
            errorMessage: 'Ingresa un apellido paterno válido',
            required: true,
        },
        apMaterno: {
            error: false,
            errorMessage: 'Ingresa un apellido materno válido',
            required: true,
        },
        numeroCelular: {
            error: false,
            errorMessage: 'Ingresa un número de celular a diez dígitos válido',
            regexp: /^[0-9]{10}$/,
            required: true,
        },
        correo: {
            error: false,
            errorMessage: 'Ingresa un correo válido',
            regexp: /^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-.]+$/,
            required: true,
        },
        curp: {
            error: false,
            errorMessage: 'Ingresa una CURP válida',
            regexp: /^[A-Z]{1}[AEIOUX]{1}[A-Z]{2}\d{2}(0[1-9]|1[0-2])(0[1-9]|[12]\d|3[01])[HM]{1}(AS|BC|BS|CC|CS|CH|CL|CM|DF|DG|GT|GR|HG|JC|MC|MN|MS|NT|NL|OC|PL|QT|QR|SP|SL|SR|TC|TS|TL|VZ|YN|ZS|NE)[B-DF-HJ-NP-TV-Z]{3}[A-Z\d]{1}\d{1}$/,
        },
        pasaporte: {
            error: false,
            errorMessage: 'Ingresa un pasaporte o licencia válidos',
            regexp: /^[A-Z0-9]{5,15}$/i,
        },
        giroNegocio: {
            error: false,
            errorMessage: 'Escoge un giro de negocio',
            regexp: /^[a-zA-ZÀ-ÿ0-9&\s\-]{1,99}$/,
            required: true,
        },
        razonSocial: {
            error: false,
            errorMessage: 'Ingresa una razón social sin números',
            required: false,
        },
        city: {
            error: false,
            errorMessage: 'Ingresa la delegación o municipio de tu dirección',
            regexp: /^[0-9a-zA-ZÀ-ÿ\s\-]{1,40}$/,
            required: true,
        },
        suburb: {
            error: false,
            errorMessage: 'Ingresa la colonia de tu dirección',
            regexp: /^[0-9a-zA-ZÀ-ÿ\s\-\(\)]{1,40}$/,
            required: true,
        },
        street: {
            error: false,
            errorMessage: 'Ingresa la calle de tu dirección',
            regexp: /^[0-9a-zA-ZÀ-ÿ\s\.\-\(\)]{1,40}$/,
            required: true,
        },
        externalNumber: {
            error: false,
            errorMessage: 'Ingresa el número',
            regexp: /^[0-9a-zA-ZÀ-ÿ\s\-]{1,40}$/,
            required: true,
        },
        state: {
            error: false,
            errorMessage: 'Ingresa el estado de tu dirección',
            regexp: /^[0-9a-zA-ZÀ-ÿ\s\-]{1,40}$/,
            required: true,
        },
        internalNumber: {
            error: false,
            errorMessage: '',
            regexp: /^[0-9a-zA-ZÀ-ÿ\s\-]{1,40}$/,
            required: false,
        },
        betweenStreets1: {
            error: false,
            errorMessage: 'Ingresa una calle válida',
            regexp: /^[0-9a-zA-ZÀ-ÿ\s\-]{1,40}$/,
            required: true,
        },
        betweenStreets2: {
            error: false,
            errorMessage: 'Ingresa una calle válida',
            regexp: /^[0-9a-zA-ZÀ-ÿ\s\-]{1,40}$/,
            required: true,
        },
        addressReference: {
            error: false,
            errorMessage: 'Ingresa una referencia válida',
            regexp: /^[0-9a-zA-ZÀ-ÿ\s]{1,40}$/,
            required: true,
        },
        rfc: {
            error: false,
            errorMessage: 'Ingresa un R.F.C con formato valido',
            regexp: /^([a-zñA-ZÑ&]{3,4}) ?(?:- ?)?(\d{2}(?:0[1-9]|1[0-2])(?:0[1-9]|[12]\d|3[01])) ?(?:- ?)?([a-zA-Z\d]{2})([aA\d])$/,
            required: true,
        },
        codigoCfdi: {
            error: false,
            errorMessage: 'Selecciona el uso de CFDI',
            regexp: /^[,0-9a-zA-ZÀ-ÿ\s\-]{1,200}$/,
            required: true,
        },
        regimenFiscal: {
            error: false,
            errorMessage: 'Selecciona el régimen fiscal',
            regexp: /^[,0-9a-zA-ZÀ-ÿ\s\-]{1,200}$/,
            required: true,
        },
        billingPostalCode: {
            error: false,
            errorMessage:
                'Ingresa el código postal de tu dirección de facturación',
            regexp: /^[0-9]{5}$/,
            required: true,
        },
        billingCity: {
            error: false,
            errorMessage:
                'Ingresa la delegación o municipio de tu dirección de facturación',
            regexp: /^[0-9a-zA-ZÀ-ÿ\s\-]{1,40}$/,
            required: true,
        },
        billingSettlement: {
            error: false,
            errorMessage: 'Ingresa la colonia de tu dirección de facturación',
            regexp: /^[0-9a-zA-ZÀ-ÿ\s\-]{1,40}$/,
            required: true,
        },
        billingStreet: {
            error: false,
            errorMessage: 'Ingresa la calle de tu dirección de facturación',
            regexp: /^[0-9a-zA-ZÀ-ÿ\s\-]{1,40}$/,
            required: true,
        },
        billingExteriorNumber: {
            error: false,
            errorMessage: 'Ingresa el número',
            regexp: /^[0-9a-zA-ZÀ-ÿ\s\-]{1,40}$/,
            required: true,
        },
        billingState: {
            error: false,
            errorMessage: 'Ingresa el estado de tu dirección de facturación',
            regexp: /^[0-9a-zA-ZÀ-ÿ\s\-]{1,40}$/,
            required: true,
        },
        billingInteriorNumber: {
            error: false,
            errorMessage: 'Ingresa un número interior válido',
            regexp: /^\d+[a-zA-Z]?(?:\s?[a-zA-Z]?)?$/,
            required: false,
        },
        postalCode: {
            error: false,
            errorMessage: 'Ingresa el código postal de tu dirección',
            regexp: /^[0-9]{5}$/,
            required: true,
        },
    };
    export const mapFields = {
        address: {
            error: false,
            errorMessage: 'Ingresa una dirección válida',
            regexp: /^[0-9a-zA-ZÀ-ÿ()[\].,#\-][0-9a-zA-ZÀ-ÿ()[\]\s\.,#\-]{0,98}$/,
            required: true,
        },

        exterior: {
            error: false,
            errorMessage: 'Ingresa un número exterior válido',
            regexp: /^[0-9a-zA-ZÀ-ÿ\s\-]{1,40}$/,
            required: true,
        },
        interior: {
            error: false,
            errorMessage: 'Ingresa un número interior válido',
            regexp: /^[0-9a-zA-ZÀ-ÿ\s\-]{1,40}$/,
            required: false,
        },
        neighborhood: {
            error: false,
            errorMessage: 'Ingresa una colonia válida',
            regexp: /^[0-9a-zA-ZÀ-ÿ\s\-\(\)]{1,40}$/,
            required: true,
        },
        postalCode: {
            error: false,
            errorMessage: 'Ingresa un código postal válido',
            regexp: /^[0-9]{5}$/,
            required: true,
        },
        city: {
            error: false,
            errorMessage: 'Ingresa una ciudad válida',
            regexp: /^[0-9a-zA-ZÀ-ÿ\s\-]{1,40}$/,
            required: true,
            disabled: true,
        },
        state: {
            error: false,
            errorMessage: 'Ingresa un estado válido',
            regexp: /^[0-9a-zA-ZÀ-ÿ\s\-]{1,40}$/,
            required: true,
            disabled: true,
        },
        betweenStreet1: {
            error: false,
            errorMessage: 'Ingresa una calle válida',
            regexp: /^[0-9a-zA-ZÀ-ÿ][0-9a-zA-ZÀ-ÿ\s\.,#\-]{1,40}$/,
            required: true,
        },
        betweenStreet2: {
            error: false,
            errorMessage: 'Ingresa una calle válida',
            regexp: /^[0-9a-zA-ZÀ-ÿ\s\-]{1,40}$/,
            required: true,
        },
        addressReference: {
            error: false,
            errorMessage: 'Ingresa una referencia válida',
            regexp: /^[0-9a-zA-ZÀ-ÿ\s]{1,40}$/,
            required: true,
        },
    };

    export const userAccountFields = {
        correo: {
            error: false,
            errorMessage: 'Ingresa un correo válido',
            regexp: /^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-.]+$/,
            required: true,
        },
        password: {
            error: false,
            errorMessage: 'Este campo es requerido',
            //regexp: /^[a-zA-Z0-9\_\-]/
            regexp: /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!¡@#$%^&*()_=\\[\\{};\\:"\\|,.<>\/?¿+\\-])(.{10,20}$)/,
            required: true,
        },
    };

    export const accountDetailsFields = {
        nombre: {
            error: false,
            errorMessage: 'Ingresa un nombre válido',
            required: true,
        },
        apPaterno: {
            error: false,
            errorMessage: 'Ingresa un apellido paterno válido',
            required: true,
        },
        apMaterno: {
            error: false,
            errorMessage: 'Ingresa un apellido materno válido',
            required: true,
        },
        numeroCelular: {
            error: false,
            errorMessage: 'Ingresa un número de celular a diez dígitos válido',
            regexp: /^[0-9]{10}$/,
            required: true,
        },
        correo: {
            error: false,
            errorMessage: 'Ingresa un correo válido',
            regexp: /^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-.]+$/,
            required: true,
        },
        curp: {
            error: false,
            errorMessage: 'Ingresa una CURP válida',
            regexp: /^[A-Z]{1}[AEIOUX]{1}[A-Z]{2}\d{2}(0[1-9]|1[0-2])(0[1-9]|[12]\d|3[01])[HM]{1}(AS|BC|BS|CC|CS|CH|CL|CM|DF|DG|GT|GR|HG|JC|MC|MN|MS|NT|NL|OC|PL|QT|QR|SP|SL|SR|TC|TS|TL|VZ|YN|ZS|NE)[B-DF-HJ-NP-TV-Z]{3}[A-Z\d]{1}\d{1}$/,
        },
        pasaporte: {
            error: false,
            errorMessage: 'Ingresa una Pasaporte o Licencia válida',
            regexp: /^[A-Z0-9]{5,15}$/i,
        },
        giroNegocio: {
            error: false,
            errorMessage: 'Escoge un giro de negocio',
            regexp: /^[a-zA-ZÀ-ÿ0-9&\s\-]{1,99}$/,
            required: true,
        },
        razonSocial: {
            error: false,
            errorMessage: 'Ingresa una razón social sin números',
            required: false,
        },
    };

    export const codeValidationFields = {
        codigoVerificacion: {
            required: true,
            minLength: 4,
            maxLength: 4,
            regexp: /^[0-9]{4}$/,
            errorMessage:
                'El código que ingresaste no es válido, vuelve a intentarlo.',
        },
    };
</script>
